import React from 'react';
import useAuth from '../hooks/useAuth';
import { PrivateRoutes } from './Private.routes';
import { PublicRoutes } from './Public.routes';
import { Loading } from '../components/Loading';
import { Flex } from '@chakra-ui/react';


function AplicationRoutes() {
    const { isLoggedin, carregandoSessao } = useAuth();

    // Enquanto a sessao nao resolve, nenhuma rota e renderizada. Renderizar antes
    // faria as rotas publicas mandarem uma URL privada para /login com `replace`,
    // perdendo o endereco que a pessoa pediu.
    if (carregandoSessao) {
        return (
            <Flex minH="100vh" align="center" justify="center">
                <Loading />
            </Flex>
        );
    }

    return (
        <>
            {isLoggedin ? <PrivateRoutes /> : <PublicRoutes />}
        </>
    );
}

export default AplicationRoutes;
